import React,{Components}from 'react';
import './App.css';
import TabNav from './components/TabNav';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const {Zilliqa} = require('@zilliqa-js/zilliqa');
const zilliqa = new Zilliqa('https://dev-api.zilliqa.com');
const {BN, Long, bytes, units} = require('@zilliqa-js/util');
const {toBech32Address, fromBech32Address} = require('@zilliqa-js/crypto');
const { StatusType, MessageType } = require('@zilliqa-js/subscriptions');


export default class App extends React.Component {
constructor(props){
  super(props)
  this.state={
 

  }

}

componentDidMount() {

}



  render(){

  return (
    <div className="App">
      <header className="App-header">
        <a href='https://drive.google.com/file/d/1xaLxa2Zo7KtT7m5JiZNfP4vPv_w9JqPK/view?usp=sharing'>DarkPaper</a>
   
      </header>
      <TabNav/>
      
    </div>
  );
  }
}